import { AppRoute, MenuActionId } from '@common/enums'

type HandleNewActionClickParams = {
  navigateTo: (path: string) => void
  navigateOrRedirect: (route: string) => void
  openProjectDialogOrRedirect: () => void
}

export function handleNewActionClick(item: string, params: HandleNewActionClickParams) {
  const { navigateTo, navigateOrRedirect, openProjectDialogOrRedirect } = params

  switch (item) {
    case MenuActionId.ADD_NEW_SERVICE:
      navigateTo(AppRoute.SERVICE_DEPLOYMENT_METHOD)
      break
    case MenuActionId.ADD_NEW_PROJECT:
      openProjectDialogOrRedirect()
      break
    case MenuActionId.ADD_NEW_WORKSPACE:
      navigateOrRedirect(AppRoute.WORKSPACE_CREATE)
      break
  }
}
